module.exports = __webpack_public_path__ + "img/NL.e53fc83f.svg";